import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { Router, ActivatedRoute } from '@angular/router';

import { ProgrammingUtilsService as Utils } from '../../common/services/utils.service';
import { BaseRoutingComponent } from '../../common/base-routing/base-routing.component';
import { ScheduleEvent, ScheduleQuickstartContext } from '../../quickstarts/quickstart-schedule/services/schedule.service';
import { SharedProgrammingService, CommonProgrammingContext } from './../../common/services/shared-programming.service';
import { ScheduleProgrammingService } from './../../quickstarts/quickstart-schedule/services/schedule.service';
import { EVENTS_FILTER } from '../events/eventsUI.service';

@Component({
  selector: 'prg-today',
  templateUrl: './today.component.html',
  styleUrls: ['./today.component.less']
})
export class TodayComponent extends BaseRoutingComponent implements OnInit {
  currentGrouping: Observable<any>;
  searchText: Observable<string>;
  expanded: Observable<boolean>;
  initialized: Observable<boolean>;
  scheduleEvents: Observable<ScheduleEvent[]>;

  filterMenuOpen: boolean;
  showingSearch: boolean;

  @Input() creatorFilter: EVENTS_FILTER;

  @ViewChild('filterMenu') filterMenu;

  constructor(
    protected router: Router,
    private route: ActivatedRoute,
    protected shared: SharedProgrammingService,
    protected store: Store<{
      scheduleProgramming: ScheduleQuickstartContext,
      sharedProgramming: CommonProgrammingContext
    }>,
    private schedule: ScheduleProgrammingService
  ) {
    super();

    this.expanded = this.shared.listExpanded;
    this.initialized = this.store.select(s => s.sharedProgramming.initialized);
    this.scheduleEvents = this.store.select(s => s.scheduleProgramming.scheduleEvents);
    this.searchText = this.store.select(s => s.sharedProgramming.searchText);
  }

  ngOnInit() {
    this.shared.setGrouping('today');
    this.schedule.refresh();
  }

  toggleExpand() {
    this.shared.toggleListExpanded();
  }

  private tileClicked(item: any) {
    console.log('tile clicked: ', item);
    if (item) {
      // NOTE selected event has to be set manually for schedule events
      this.shared.setSelectedEvent(item);
      this.router.navigate(['when-then', 'device', item.deviceId, 'event', item.eventId, 'edit'], { relativeTo: this.moduleRoot });
    }
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/today/today.component.ts